<template>
    <v-navigation-drawer
        id="appDrawer"
        :mini-variant.sync="mini"
        :dark="$vuetify.dark"
        fixed app
        v-model="drawer"
        width="260"
    >
        <v-toolbar color="primary darken-1" dark>
            <img
                :src="logo"
                height="42"
                width="208"
                :alt="altLogo"
                @click="$router.push({ path: '/' });"
            />
            <v-toolbar-title class="ml-0 pl-3">
                <span class="hidden-sm-and-down"></span>
            </v-toolbar-title>
        </v-toolbar>
        <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
            <v-alert
                :value="isOffline"
                color="warning"
                icon="priority_high"
            >{{ offlineMsg }}</v-alert>
            <v-list dense expand>
                <template v-for="(item, i) in menu">
                    <!--group with subitems-->
                    <v-list-group v-if="item.items" :key="item.name" :group="item.group" :prepend-icon="item.icon" no-action="no-action">
                        <v-list-tile slot="activator" ripple="ripple">
                            <v-list-tile-content>
                                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <template v-for="(subItem, i) in item.items">
                            <!--sub group-->
                            <v-list-group v-if="subItem.items" :key="subItem.name" :group="subItem.group" sub-group="sub-group">
                                <v-list-tile slot="activator" ripple="ripple">
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile v-for="(grand, i) in subItem.children" :key="i" :to="genChildTarget(item, grand)" :href="grand.href" ripple="ripple">
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list-group>
                            <!--child item-->
                            <v-list-tile v-else :key="i" :to="genChildTarget(item, subItem)" :href="subItem.href" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple">
                                <v-list-tile-content>
                                    <v-list-tile-title><span>{{ subItem.title }}</span></v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action v-if="subItem.action">
                                    <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                        </template>
                    </v-list-group>
                    <v-subheader v-else-if="item.header" :key="i">{{ item.header }}</v-subheader>
                    <v-divider v-else-if="item.divider" :key="i"></v-divider>
                    <!--top-level link-->
                    <v-list-tile v-else :to="!item.href ? { name: item.name } : null" :href="item.href" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="item.name">
                        <v-list-tile-action v-if="item.icon">
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action v-if="item.subAction">
                            <v-icon class="success--text">{{ item.subAction }}</v-icon>
                        </v-list-tile-action>
                    </v-list-tile>
                </template>
            </v-list>
        </vue-perfect-scrollbar>
    </v-navigation-drawer>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    import { logo, altLogo   } from '@/global';
    import { mapState        } from 'vuex';

    export default {
        name       : 'app-drawer',
        components : {
            VuePerfectScrollbar,
        },
        props      : {
            expanded : {
                type    : Boolean,
                default : true
            },
        },
        data       : () => ({
            route          : 'menu',
            mini           : false,
            drawer         : true,
            scrollSettings : {
                maxScrollbarLength : 160
            }
        }),
        computed   : {
            ...mapState(['user']),
            computeGroupActive () {
                return true;
            },
            logo () {
                return logo;
            },
            altLogo () {
                return altLogo;
            },
            offlineMsg() {
                return 'O sistema está no modo Offline.';
            },
            sideToolbarColor () {
                return this.$vuetify.options.extra.sideNav;
            },
            menu() {
                const perfis = ['Administrador', 'Funcionário'];
                const menus  = {
                    "Administrador" : {
                        "online" : [
                            {
                                "header" : "Reembolso"
                            },
                            {
                                "title" : "Relatórios",
                                "icon" : "file_copy",
                                "name" : "relatorios"
                            },
                            {
                                "header" : "Configurações"
                            },
                            {
                                "title" : "Administrativo",
                                "group" : "admin",
                                "icon" : "settings",
                                "items" : [
                                    {
                                        "name" : "usuarios",
                                        "title" : "Usuários",
                                        "component" : "usuarios"
                                    },
                                    {
                                        "name" : "categorias",
                                        "title" : "Categorias",
                                        "component" : "categorias"
                                    }
                                ]
                            }
                        ],
                        "offline" : [
                            {
                                "header" : "Reembolso"
                            },
                            {
                                "title" : "Relatórios",
                                "icon" : "file_copy",
                                "name" : "relatorios"
                            }
                        ],
                    },
                    "Funcionário"   : [
                        {
                            "header" : "Reembolso"
                        },
                        {
                            "title" : "Projetos",
                            "icon"  : "file_copy",
                            "name"  : "relatorios"
                        }
                    ]
                }

                if (this.hasProfile(perfis[0])) {
                    return menus[perfis[0]][this.isOnline ? 'online' : 'offline'];
                } else if (this.hasProfile(perfis[1])) {
                    return menus[perfis[1]];
                } else {
                    return [];
                }
            }
        },
        mounted() {
            window.getApp.$on('APP_DRAWER_TOGGLED', () => {
                this.drawer = (!this.drawer);
            });
            // this.getMenu();
        },
        methods    : {
            hasProfile(profile) {
                return this.user.perfis.some(perfil => perfil === profile)
            },
            genChildTarget (item, subItem) {
                if (subItem.href) return;
                if (subItem.component) {
                    return {
                        name: subItem.component,
                    };
                }
                return { name: `${item.group}/${(subItem.name)}` };
            },
            // getMenu() {
            //     this.loading = true;
            //     if (this.isOnline) {
            //         console.log('isOnline [getMenu()]');
            //         const perfis = ['Administrador', 'Funcionário'];
            //         let filter   = '';
            //         this.$axios.get(`${this.route}${filter}`).then(response => {
            //             // console.log('getMenu():', response.data);
            //             this.menu = response.data.items[0].menu;
            //             this.$offlineStorage.set(`menu`, this.menu);
            //         }).then(() => {
            //             // console.log('getMenu', this.menu);
            //             this.loading = false;
            //         });
            //     } else {
            //         console.log('isOffline [getMenu()]');
            //         this.menu    = this.$offlineStorage.get(`menu`);
            //         this.loading = false;
            //     }
            // }
        }
    };
</script>

<style lang="stylus">
// @import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl';

#appDrawer
    overflow: hidden
    .drawer-menu--scroll
        height: calc(100vh - 48px)
        overflow: auto
</style>
